import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeader from '../../components/common/PageHeader';

const Dashboard = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-primary-50 pb-8">
      <PageHeader
        title={t('admin.dashboard')}
        subtitle="Overview and management tools for Gurukul Fundraiser"
        icon={
          <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
          </svg>
        }
      />
      <div className="max-w-7xl mx-auto px-4">

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-bold text-gray-900 mb-4">{t('admin.quickActions')}</h2>
            <div className="space-y-2">
              <Link to="/admin/users" className="block px-4 py-2 bg-primary-50 text-primary-700 rounded-lg hover:bg-primary-100 transition">
                {t('admin.manageUsersKyc')}
              </Link>
              <Link to="/admin/gurukuls" className="block px-4 py-2 bg-primary-50 text-primary-700 rounded-lg hover:bg-primary-100 transition">
                {t('admin.manageGurukuls')}
              </Link>
              <Link to="/admin/donations" className="block px-4 py-2 bg-primary-50 text-primary-700 rounded-lg hover:bg-primary-100 transition">
                {t('admin.viewDonations')}
              </Link>
              <Link to="/admin/vouchers" className="block px-4 py-2 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition border border-green-200 font-medium">
                {t('admin.vouchers.title')}
              </Link>
              <Link to="/admin/admins" className="block px-4 py-2 bg-primary-50 text-primary-700 rounded-lg hover:bg-primary-100 transition">
                {t('admin.manageAdmins')}
              </Link>
              <div className="block px-4 py-2 bg-indigo-50/50 text-indigo-400 rounded-lg cursor-not-allowed opacity-70 border border-indigo-100 flex justify-between items-center group">
                <span>📂 Upload RAG Documents</span>
                <span className="text-[10px] bg-indigo-100 px-1.5 py-0.5 rounded text-indigo-500 uppercase font-bold tracking-wider">Coming Soon</span>
              </div>
              <div className="block px-4 py-2 bg-indigo-50/50 text-indigo-400 rounded-lg cursor-not-allowed opacity-70 border border-indigo-100 flex justify-between items-center group">
                <span>❓ Manage FAQ & Chatbot</span>
                <span className="text-[10px] bg-indigo-100 px-1.5 py-0.5 rounded text-indigo-500 uppercase font-bold tracking-wider">Coming Soon</span>
              </div>
              <Link to="/admin/counters" className="block px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition border border-gray-200">
                📊 Page View Counters
              </Link>
              <Link to="/admin/banner" className="block px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition shadow-sm font-medium text-center">
                🖼️ Manage Hero Banner
              </Link>
              <Link to="/admin/bank-details" className="block px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition shadow-sm font-medium text-center">
                🏦 Manage Bank Details
              </Link>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-bold text-gray-900 mb-4">{t('admin.recentActivity')}</h2>
            <p className="text-gray-600">{t('admin.noRecentActivity')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
